import React from 'react';

import { DAYS, MONTHS, YEARS } from '../../utils/dates';
import { DropdownField } from '../FormFields';

interface DateOfBirthFieldProps {
  disableDobInput: boolean;
  error?: string;
}

const DateOfBirthField = ({ error, disableDobInput }: DateOfBirthFieldProps) => {
  return (
    <>
      <div className="dob-container mt-24 mb-12 flex items-center">
        <div className="text-primary-red text-body-sm uppercase font-bold font-sans">Birthday</div>
        <div className="ml-12 flex-1 bg-primary-red h-2"></div>
      </div>
      <div className="flex items-center space-x-6">
        <div className="w-5/12">
          <DropdownField
            name="month"
            options={MONTHS}
            placeholder="Month"
            isDisabled={disableDobInput}
          />
        </div>
        <div className="w-3/12">
          <DropdownField name="day" options={DAYS} placeholder="Day" isDisabled={disableDobInput} />
        </div>
        <div className="w-4/12">
          <DropdownField
            name="year"
            options={YEARS}
            placeholder="Year"
            isDisabled={disableDobInput}
          />
        </div>
      </div>
      {error && <div className="text-primary-red text-body-sm mt-6">{error}</div>}
    </>
  );
};

export default DateOfBirthField;
